module.exports = __webpack_public_path__ + "img/cmx-overview.53bd76aa.webp";